import React from "react";
import "../Style.css";
import { HashLink } from 'react-router-hash-link';
import { Link } from "react-router-dom";

const Footer = () => {

  const isTestimonialActive = window.location.hash === '#testimo';
  const isPortfolioActive = window.location.hash === '#portfolio';

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-left">
          <div className="foot-left2">
          <h2>Have a project idea! Let’s work together.</h2>
          <p>
            Nunc vel metus cursus, tempor ipsum sit amet, rutrum justo. Maecenas
            tincidunt imperdiet magna, et porta libero eleifend vel.
          </p>
          <Link to="/Hire"><button className="footer-button">Get A Quote</button></Link>

          </div>
        </div>
        <div className="footer-right">
 
        <div className="social1">
        <Link to="https://www.facebook.com/hatchcoders">  <img src="/Images/foot1.svg" alt="facebook"></img></Link>
        <Link to="https://www.linkedin.com/company/hatchcoders/">  <img src="/Images/foot3.svg" alt="Linkedin"></img></Link>
        <Link to="https://www.instagram.com/hatch_coders/">   <img src="/Images/foot4.svg" alt="Instagram"></img></Link>
        <Link to="https://www.youtube.com/@HatchCoders">   <img src="/Images/foot5.svg" alt="Youtube"></img></Link>
        </div>
        <hr></hr>

       <div className="footer-links">
            <div>
              <h2>Quick Links</h2>
              <ul>
                <li>
                <HashLink
                      smooth
                      className={`footer-link ${isPortfolioActive ? 'active' : ''}`}
                      to="/#portfolio"
                    >
                      Portfolio
                    </HashLink>
                </li>
                <li>
                  <Link to="/aboutus">About</Link>
                </li>
                <li>
                  <Link to="/Service">Services</Link>
                </li>
                <li>
                  <Link to="/blog">Blog</Link>
                </li>
                <li>
                  <HashLink
                      smooth
                      className={`footer-link ${isTestimonialActive ? 'active' : ''}`}
                      to="/#testimo"
                    >
                      Testimonial
                    </HashLink>
                </li>
                {/* <li>
                  <Link to="#pricing-plans">Pricing Plans</Link>
                </li> */}
                <li>
                  <Link to="/Hire">Contact</Link>
                </li>
              </ul>
            </div>
            <div>
              <h2>Services</h2>
              <ul>
                <li>
                  <Link to="https://www.hatchcoders.com/Service">UI/UX Design</Link>
                </li>
                <li>
                  <Link to="https://www.hatchcoders.com/Service">Mobile App Development</Link>
                </li>
                <li>
                  <Link to="https://www.hatchcoders.com/Service">Web App Development</Link>
                </li>
                <li>
                  <Link to="https://www.hatchcoders.com/Service">Game Design 2D/3D</Link>
                </li>
                <li>
                  <Link to="https://www.hatchcoders.com/Service">Game Development</Link>
                </li>
                <li>
                  <Link to="https://www.hatchcoders.com/Service">Web Game Development</Link>
                </li>
              </ul>
            </div>
            <div>
              <h2>Expertise</h2>
              <ul>
                <li>
                   <HashLink
                      smooth
                      className={`footer-link ${isPortfolioActive ? 'active' : ''}`}
                      to="/#portfolio"
                    >
                      E-commerce App Development
                    </HashLink>
                 
                </li>
                <li>
                   <HashLink
                      smooth
                      className={`footer-link ${isPortfolioActive ? 'active' : ''}`}
                      to="/#portfolio"
                    >
                     Blockchain App Development
                    </HashLink>
                
                </li>
                <li>
                   <HashLink
                      smooth
                      className={`footer-link ${isPortfolioActive ? 'active' : ''}`}
                      to="/#portfolio"
                    >
                     Fintech App Development
                    </HashLink>
                  
                </li>
                <li>
                   <HashLink
                      smooth
                      className={`footer-link ${isPortfolioActive ? 'active' : ''}`}
                      to="/#portfolio"
                    >
                      AR/VR App Development
                    </HashLink>
                  
                </li>
                <li>
                   <HashLink
                      smooth
                      className={`footer-link ${isPortfolioActive ? 'active' : ''}`}
                      to="/#portfolio"
                    >
                      Grocery Delivery App Development
                    </HashLink>
                  
                </li>
                <li>
                   <HashLink
                      smooth
                      className={`footer-link ${isPortfolioActive ? 'active' : ''}`}
                      to="/#portfolio"
                    >
                      Fitness Delivery App Development
                    </HashLink>
                 
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
      
        <p>Copyright © 2025 hatchcoders — All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
